// extracted by mini-css-extract-plugin
module.exports = {"deleteOverlay":"Iw","cancel":"Jw","disabled":"Kw","delete":"Lw"};